<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5">
      <h2 class="font-weight-bold text--primary">Periodos</h2>
    </v-card-title>
    <v-card-subtitle>
    </v-card-subtitle>
    <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <DataTableMain :datatable="table" :on-success='successTableAction' :itemsAction='tableAction' />
          </v-col>
        </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import { Permission } from '@/mixins/permissionMain'
export default {
  props: ['model'],
  mixins: [Permission],
  data: () => ({
    itemInsumos: {},
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' },
          { text: 'Mes', value: 'mes', class: 'black--text' },
          { text: 'Fecha Inicio', value: 'fecha_inicio', class: 'black--text' },
          { text: 'Fecha Cierre', value: 'fecha_cierre', class: 'black--text' },
          { text: 'Fecha Deposito', value: 'fecha_deposito', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain
    // InsumoPickingDialog
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapMutations([]),
    successTableAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      this.onSuccess(item)
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    model (val) {
      this.table.body.data = val.periodos
    }
  }
}
</script>

<style>

</style>
